import React from 'react'
import PropTypes from 'prop-types'

import { withStyles } from '@material-ui/core/styles'
import {
  IconButton,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core'
import { mdiPencil } from '@mdi/js'
import Tooltip from '@material-ui/core/Tooltip'

import Link from '../controls/Link'

class UnitList extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    units: PropTypes.object.isRequired,
    onEdit: PropTypes.func,
  }

  static defaultProps = {
    onEdit: () => {},
  }

  static styles = () => ({
    table: {
      width: 'auto',
    },
  })

  render() {
    const { units, classes, onEdit } = this.props

    const unitsHtml = Object.values(units).map((u) => (
      <TableRow key={u.id}>
        <TableCell>
          <Link to={`/units/${u.id}`}>{u.id}</Link>
        </TableCell>
        <TableCell>{u.name}</TableCell>
        <TableCell>{u.community_id || ''}</TableCell>
        <TableCell>{u.sku}</TableCell>
        <TableCell>{u.serial}</TableCell>
        <TableCell>{u.location.address}</TableCell>
        <TableCell>
          <Tooltip title={`Edit ${u.name}`} placement="top">
            <span>
              <IconButton aria-label="Edit" onClick={() => onEdit(u)}>
                <SvgIcon>
                  <path d={mdiPencil} />
                </SvgIcon>
              </IconButton>
            </span>
          </Tooltip>
        </TableCell>
      </TableRow>
    ))
    return (
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Id</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Community</TableCell>
            <TableCell>SKU</TableCell>
            <TableCell>Serial</TableCell>
            <TableCell>Address</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {unitsHtml}
        </TableBody>
      </Table>
    )
  }
}

export default withStyles(UnitList.styles)(UnitList)
